/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, AuthStoreService } from '../../../../core/services';
import { Injectable } from '@angular/core';
import { ModulesEnum } from '../../../../core/enums';
import { Observable, Subject } from 'rxjs';
import { ShuttleApiEnum } from '../enums/api';

@Injectable()
export class ShuttleApiService {
    /**
     * Emit when shuttles have been updated.
     */
    public shuttlesUpdatedEmitter: Subject<any> = new Subject<any>();

    constructor(
        private api: ApiService,
        private authStoreService: AuthStoreService
    ) {
    }

    /**
     * Get retrieves all adc data
     * @param namespace
     * @param id
     * @param options
     */
    public adopt(namespace: number, id: number, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.CENTRALISEDMANAGEMENT);

            this.api.patch(
                ShuttleApiEnum.PATCH_SHUTTLE_ADOPT(namespace, id),
                {},
                moduleAuth
            ).subscribe(
                (data: any) => {
                    this.shuttlesUpdatedEmitter.next(true);
                    observer.next(data.shuttles);
                    observer.complete();
                },
                (error: any) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Get retrieves all sidecars.
     * @param namespace
     * @param options
     */
    public getShuttleList(namespace: number, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.CENTRALISEDMANAGEMENT);

            this.api.get(
                ShuttleApiEnum.GET_SHUTTLE_ALL(namespace),
                moduleAuth
            ).subscribe(
                (response: any) => {
                    observer.next(response);
                    observer.complete();
                },
                (error: any) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Get retrieves specific adc data
     * @param namespace
     * @param id
     * @param options
     */
    public get(namespace: number, id: number, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.CENTRALISEDMANAGEMENT);

            this.api.get(
                ShuttleApiEnum.GET_SHUTTLE(namespace, id),
                moduleAuth
            ).subscribe(
                (data: any) => {
                    observer.next(data);
                    observer.complete();
                },
                (error: any) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Delete an adc by id via the API
     * @param namespace
     * @param id
     * @param options
     */
    public delete(namespace: number, id: number, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.CENTRALISEDMANAGEMENT);

            this.api.delete(
                ShuttleApiEnum.DELETE_SHUTTLE(namespace, id),
                moduleAuth
            ).subscribe(
                (data: any) => {
                    observer.next(data);
                    observer.complete();
                },
                (error: any) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Edit an adc by id via the API
     * @param namespace
     * @param id
     * @param data
     * @param options
     */
    public update(namespace: number, id: number, data: any, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.CENTRALISEDMANAGEMENT);

            this.api.patch(
                ShuttleApiEnum.PATCH_SHUTTLE_UPDATE(namespace, id),
                data,
                moduleAuth
            ).subscribe(
                (data: any) => {
                    observer.next(data);
                    observer.complete();
                },
                (error: any) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }
}
